import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Home from "../views/Home.vue";
import { isLogin } from "@/common/util";
import { trackPage } from "@/lib/kewlSensor/pageViewSensor";
import { LocalDataUtil } from "@/common/util";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "home",
    meta: {
      title: "home",
      auth: false,
    },
    component: Home,
  },

  {
    path: "/edit",
    name: "edit",
    meta: {
      title: "",
      auth: true,
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "edit" */ "../views/EditView.vue"),
    children: [
      {
        path: "",
        redirect: "dashboard",
      },
      // {
      //   path: "replacement",
      //   name: "replacement",
      //   meta: {
      //     title: "replacement",
      //     auth: true,
      //   },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "replacement" */ "../views/AiReplacement.vue"
      //     ),
      // },
      {
        path: "clothing",
        name: "clothing",
        meta: {
          title: "clothing",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "clothingView" */ "../views/ClothingView.vue"
          ),
      },
      {
        path: "dashboard",
        name: "dashboard",
        meta: {
          title: "dashboard",
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "clothingView" */ "../views/DashboardView.vue"
          ),
      },
      {
        path: "product",
        name: "product",
        meta: {
          title: "product",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "ProductMapView" */ "../views/ProductMapView.vue"
          ),
      },
      {
        path: "clothingTask",
        name: "clothingTask",
        meta: {
          title: "clothingTask",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "clothingTask" */ "../views/ClothingTask.vue"
          ),
      },
      // {
      //   path: "mannequin",
      //   name: "mannequin",
      //   meta: {
      //     title: "mannequin",
      //     auth: true,
      //   },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "mannequinPersonView" */ "../views/MannequinPersonView.vue"
      //     ),
      // },
      // {
      //   path: "person",
      //   name: "person",
      //   meta: {
      //     title: "person",
      //     auth: true,
      //   },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "personView" */ "../views/PersonView.vue"
      //     ),
      // },
      {
        path: "invite",
        name: "invite",
        meta: {
          title: "invite",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "inviteFriendsView" */ "../views/InviteFriendsView.vue"
          ),
      },
      {
        path: "records",
        name: "records",
        meta: {
          title: "records",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "records" */ "../views/Records.vue"),
      },

      {
        path: "recordDetail",
        name: "recordDetail",
        meta: {
          title: "recordDetail",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "recordDetail" */ "../views/RecordDetail.vue"
          ),
      },
      {
        path: "clothingWorkspace",
        name: "clothingWorkspace",
        meta: {
          title: "clothingWorkspace",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "clothingWorkspace" */ "../views/ClothingWorkspace.vue"
          ),
      },
    ],
  },
  {
    path: "/subscribe",
    name: "subscribe",
    meta: {
      title: "subscribe",
      auth: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "subscribeView" */ "../views/SubscribeView.vue"
      ),
  },
  {
    path: "/help",
    name: "help",
    meta: {
      title: "help",
    },
    component: () => import(/* webpackChunkName: "Help" */ "../views/Help.vue"),
  },
  {
    path: "*",
    redirect: "/home",
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // startTime = Date.now();
  let parm = JSON.stringify({ ...to.params, ...to.query });
  trackPage(0, from.path, parm); // 退出页面
  if (to.meta && to.meta.auth) {
    const isLoginData = isLogin();
    if (!isLoginData) {
      store.commit("setShowLogin", true);
      store.commit("setCurrentPath", "community");
      next({
        path: "/",
      });
    } else if (isLoginData === "inviteCode") {
      LocalDataUtil.removeItem("aispacewebtoken");
      LocalDataUtil.removeItem("aipacewebuserinfo");
      store.commit("setShowLogin", true);
      store.commit("setLoginStatus", "SignIn");
      next({
        path: "/",
      });
    } else {
      next();
    }
  } else {
    next();
    // console.info(this);
  }
  // next();
});

router.afterEach((to, from) => {
  let parm = JSON.stringify({ ...to.params, ...to.query });
  trackPage(1, from.path, parm); // 进入
});

export default router;
